<template>
  <q-card class="q-mt-md">
    <q-card-section class="bg-primary text-white">
      <div class="text-h4">Items del Presupuesto</div>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-table flat :rows="items" :columns="columns" row-key="name">
        <template v-slot:body-cell-producto="props">
          <q-td :props="props">
            <span>{{ props.row.producto_id }}</span><br />
            <span>{{ props.row.producto.id }}</span>
          </q-td>
        </template>
        <template v-slot:body-cell-oper="props">
          <q-td :props="props">
            <q-btn icon="delete" @click="itemDelete(props)" round dense color="red" flat size="sm" />
            <q-btn icon="edit" @click="itemEdit(props.row)" round dense color="blue" flat size="sm" />
          </q-td>
        </template>
        <template v-slot:bottom-row>
          <q-tr>
            <q-td colspan="4" class="text-right">
              <span>Total:</span>
            </q-td>
            <q-td class="text-right">
              {{ total }}
            </q-td>
            <q-td></q-td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
  </q-card>
  <q-dialog v-model="dialog" persistent>
    <component :is="componentMapping[tipoProducto]" :oper="oper" :producto="producto"></component>
  </q-dialog>
</template>

<script setup>
import { computed, toRefs,ref  } from 'vue'
import numberFormat from '@/helpers/numberFormat';
import componentMapping from '@/constants/componentMapping.js';

const dialog = ref(false);
const tipoProducto = ref('WPAN');
const producto = ref({});
const columns = [
  { name: 'producto_id', label: 'Producto', field: 'producto_id', sortable: true, format: (val, row) => `(${val}) ${row?.producto?.B1_DESC}` },
  { name: 'precio_unitario', label: 'Precio Unitario', field: 'precio_unitario', sortable: true, format: (val) => numberFormat(val) },
  {
    name: 'cantidad', label: 'Cantidad', field: 'cantidad', sortable: true,
    format: (val, row) => `${numberFormat(val, true)} ${row?.producto?.B1_UM}`
  },
  { name: 'total', label: 'Total', field: 'total', sortable: true, format: (val) => numberFormat(val) },
  { name: 'oper', label: 'Operaciones', sortable: false },
]

const total = computed(() =>
numberFormat(items.value?.reduce((x, y) => parseFloat(x) + parseFloat(y.total), 0))
);

const props = defineProps({
  oper: String,
  items: Array,
})
const { items } = toRefs(props);

const itemEdit = async (row) => {
  tipoProducto.value = row.producto.B1_WGRUP.trim();
  if (!tipoProducto.value || !componentMapping[tipoProducto.value]) {
    $q.notify({
      color: 'negative',
      message: 'Falta asignar tipo de producto web',
      icon: 'warning'
    })
    return;
  }
  producto.value = {
    precio: row.precio_unitario,
    cantidad: row.cantidad,
    productoDesc: row.producto.B1_DESC,
    alicuota: Number.parseInt(row.alicuota_id) ||  row.alicuota_id,
    empresa: Number.parseInt(row.empresa_id) ||  row.empresa_id,
  };
  dialog.value = true;
};
</script>
